import { AuthLayout } from './components/auth-layout'
import { useSignIn } from './hooks/use-sign-in'
import { TextInput } from '@/components/inputs/text-input'
import { Button } from '@/components/ui/button'
import TransfereFacilIcon from '@/assets/icons/trasnfere-facil-icon'
import { PasswordInput } from '@/components/password-input'

export const SignInPage = () => {
  const {
    state: { isPending, errors },
    actions: { handleSubmit, register },
  } = useSignIn()

  return (
    <AuthLayout imageClass="bg-manager-signin">
      <div className="w-full h-full flex flex-col">
        <div className="w-full h-34 bg-[var(--brand-blue-2)] grid place-items-center">
          <div className="flex gap-4 items-center">
            <TransfereFacilIcon />
            <h1 className="text-background text-4xl font-bold mt-2">
              Transfere fácil
            </h1>
          </div>
        </div>
        <div className="w-full h-full py-8 px-20 flex flex-col gap-8">
          <strong className="text-2xl">Acesse:</strong>

          <form
            className="w-full flex flex-col gap-8"
            noValidate
            onSubmit={handleSubmit}
          >
            <div className="flex flex-col gap-4">
              <TextInput
                {...register('email')}
                type="email"
                error={errors.email}
                variant="labelUp"
                label="E-mail"
              />
              <PasswordInput
                {...register('password')}
                error={errors.password}
                variant="labelUp"
                label="Senha"
              />
            </div>

            <div className="w-full">
              <Button disabled={isPending} isLoading={isPending}>
                Entrar
              </Button>
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  )
}
